<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 14:27:08
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-08 20:27:05
-->
<template>
  <div class="box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="enTitle === 'fwqsj' ? '50%' : '35%'"
      :before-close="handleClose"
    >
      <ls-auditorium v-if="enTitle === 'lsdjt'"></ls-auditorium>
      <demand-dialog v-if="enTitle === 'sqlfx'"></demand-dialog>
      <service-coupon-data v-if="enTitle === 'fwqsj'"></service-coupon-data>
      <policy-dialog v-if="enTitle === 'zcdxyfbl'"></policy-dialog>
      <code-activity v-if="enTitle === 'mshd'"></code-activity>
      <ls-flow v-if="enTitle === 'yyzllqs'"></ls-flow>
      <active-users v-if="enTitle === 'hyyhzb'"></active-users>
      <ls-traffic v-if="enTitle === 'lssllzb'"></ls-traffic>
    </el-dialog>
  </div>
</template>

<script>
import LsAuditorium from './dialogComponents/ls-auditorium.vue'
import DemandDialog from './dialogComponents/demandDialog.vue'
import ServiceCouponData from './dialogComponents/service-coupon-data.vue'
import LsTraffic from './dialogComponents/ls-traffic.vue'
import LsFlow from './dialogComponents/ls-flow.vue'
import PolicyDialog from './dialogComponents/policyDialog.vue'
import CodeActivity from './dialogComponents/code-activity.vue'
import ActiveUsers from './dialogComponents/active-users.vue'
export default {
  name: 'CockpitTitle',
  data() {
    return {}
  },
  components: {
    LsAuditorium,
    DemandDialog,
    LsFlow,
    ServiceCouponData,
    PolicyDialog,
    ActiveUsers,
    CodeActivity,
    LsTraffic
  },
  props: {
    title: {
      type: String
    },
    isShowDialog: {
      type: Boolean,
      default: false
    },
    enTitle: {
      type: String
    }
  },
  computed: {
    dialogVisible() {
      return this.isShowDialog
    }
  },
  methods: {
    handleClose() {
      const data = {
        title: this.$store.getters.dialogInfo.title,
        enTitle: this.$store.getters.dialogInfo.enTitle,
        show: false
      }
      this.$store.dispatch('cockpit/getDialogInfo', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
}
/deep/ .el-dialog__wrapper {
  .el-dialog {
    height: 5.39rem;
    box-shadow: inset 0px 0.01rem 0.18rem 0px rgba(0, 186, 255, 1);
    border: 0.01rem solid rgba(52, 200, 255, 1);
    padding: 0.07rem;
    background: #002b4e;
    .el-dialog__body {
      height: 85%;
      padding: 0.1rem;
      overflow-y: auto;
      padding: 15px 20px;
    }
    .el-dialog__header {
      padding: 0.08rem 0;
      font-size: 0.24rem;
      .el-dialog__title {
        color: white;
        padding-left: 40px;
        display: inline-block;
        height: 0.45rem;
        width: 3rem;
        line-height: 0.45rem;
        background: linear-gradient(
          to right,
          rgba(14, 41, 205, 0.02),
          rgba(0, 136, 255, 0.55),
          rgba(2, 27, 87, 0.07),
          rgba(0, 119, 255, 0)
        );
      }
    }
  }
}
</style>
<style>
::-webkit-scrollbar {
  width: 0.06rem;
  height: 0.06rem;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.1rem;
  box-shadow: inset 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  box-shadow: inset 0 0 0.06rem rgba(0, 0, 0, 0);
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
